import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FlagFallback = styled(Box)(({ theme }) => ({
    width: 32,
    height: 20,
    backgroundColor: theme.palette.grey[400],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.shape.borderRadius,
}));

export const FlagLabel = styled(Typography)(({ theme }) => ({
    color: theme.palette.common.white,
}));

export const LangInputWrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
});

export const LabelWrapper = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
});

export const StyledLabel = styled(Typography)({
    fontWeight: 500,
});